Vue.component('WiseflowMatchUserActivity', () => import('./MatchUserActivity'))
Vue.component('WiseflowMatchFlow', () => import('./MatchFlow'))
Vue.component('WiseflowSisYearMapping', () => import('./SISYearMapping'))